import React from 'react'
import Image from 'next/image'

import { PrismicRichText } from '@prismicio/react'
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next'

type DataObject = Record<string, any>

const Heading3 = ({ children }: { children: React.ReactNode }) => <h3 className="mt-4">{children}</h3>

const SocialProofInThePress = ({ item }: { item: DataObject }) => {
  return (
    <div className="h-full">
      <p className="uppercase text-primary-green-85">{item.type}</p>
      <div className="flex h-full flex-col justify-between">
        <PrismicRichText
          field={item.title}
          components={{
            heading3: ({ children }) => <Heading3>{children}</Heading3>,
          }}
        />

        <div className="mb-8 flex items-center justify-between">
          <PrismicNextImage field={item.organization_logo} width={46} height={46} fallbackAlt="" />

          <button className="btn btn-text btn-interaction !w-fit">
            <PrismicNextLink field={item.button_link}>
              {item.button_text}
              <Image src="/images/angle-right-green.svg" width={20} height={16} alt="" aria-hidden="true" />
            </PrismicNextLink>
          </button>
        </div>
      </div>
    </div>
  )
}

export default SocialProofInThePress
